import React, {Component} from 'react';
import {connect} from 'react-redux';
import {BASENAME} from "../constants";
import {Link} from 'react-router-dom';

class Header extends Component {
    renderGreeting() {
        let returnUrl = window.location.href;
        returnUrl = returnUrl.split("return_url=")[1] || returnUrl;
        switch (this.props.user) {
            case null:
            case false:
                // return <a href={BASENAME + "/auth/google?return_url=" + returnUrl}>Google Login</a>; // TODO: uncomment for development on localhost and comment out Saml
                return <a href={BASENAME + "/auth/login?return_url=" + returnUrl}>Login</a>; // TODO: uncomment for production on server for Saml login and comment out Google
            default:
                return (
                    <div className = 'header-user-display' style={{'--header-current-user-color':process.env.REACT_APP_HEADER_CURRENT_USER_COLOR}}>
                        {this.props.user.display_name}<br/>
                    <a href={BASENAME + "/auth/logout"}>Log out</a>
                    </div>
                );
        }
    }

    render() {
        return (
            <div className='header' 
            style ={{'--header-background-color':process.env.REACT_APP_HEADER_BACKGROUND_COLOR,
            '--header-text-color':process.env.REACT_APP_HEADER_TEXT_COLOR,
            '--header-link-color':process.env.REACT_APP_HEADER_LINK_COLOR,
            }}>
                <Link to={this.props.user ? "/" : "/login"}>Home</Link>
                {this.renderGreeting()}
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {user: state.user};
}

export default connect(mapStateToProps)(Header);
